import {BaseContainerModel} from '../../base-container.model';
import { bl_mkp_mst_label_link_RowClass} from '../../../dbschema';

export class MkpLabelLinkContainerModel extends BaseContainerModel {
  bl_mkp_mst_label_link: bl_mkp_mst_label_link_RowClass = new bl_mkp_mst_label_link_RowClass();
}